module.exports = __webpack_public_path__ + "img/concrete_dark_gray_ba_list.0e507ca1.jpg";